import React, { FC, useLayoutEffect, useState } from 'react';
import classNames from 'classnames';
import { LightHeader } from '../../header/light/LightHeader';
import { SearchHeader } from '../../header/search/SearchHeader';
import { Navigation } from '../../navigation/Navigation';
import styles from './page_layout.module.scss';
import { ScrollToTop } from '../../components/ScrollToTop';
import { Footer } from '../../footer/Footer';

type Props = { subHeader?: React.ReactElement; isMarketingLayout?: boolean };

export const PageLayout: FC<Props> = ({
  children,
  isMarketingLayout = false,
  subHeader,
}) => {
  /** Temporary solution to set page content padding top according to header height */
  const getHeaderHeight = () => {
    const minHeaderHeight = 65;

    return (
      (document &&
        document.getElementById('nav')?.getBoundingClientRect().height) ||
      minHeaderHeight
    );
  };

  const [pageContentPaddingTop, setPageContentPaddingTop] = useState(
    getHeaderHeight(),
  );

  const updatePageContentPaddingTop = () => {
    const newHeight = getHeaderHeight();
    if (newHeight !== pageContentPaddingTop) {
      setPageContentPaddingTop(newHeight);
    }
  };

  useLayoutEffect(() => {
    updatePageContentPaddingTop();
  }, [subHeader, isMarketingLayout]);

  useLayoutEffect(() => {
    updatePageContentPaddingTop();
    window.addEventListener('resize', updatePageContentPaddingTop);
    return () =>
      window.removeEventListener('resize', updatePageContentPaddingTop);
  }, []);

  return (
    <ScrollToTop>
      {isMarketingLayout && (
        <LightHeader source="nav">
          <Navigation />
        </LightHeader>
      )}
      {!isMarketingLayout && <SearchHeader subHeader={subHeader} />}

      <div
        className={classNames({
          [styles.content]: !isMarketingLayout,
        })}
        style={{ paddingTop: pageContentPaddingTop }}
      >
        {children}
      </div>
      <Footer />
    </ScrollToTop>
  );
};
